export default __webpack_public_path__ + "static/media/dbvector.fe9d3806.svg";